import { VOICE_INSTRUCTIONS_MAX_LENGTH } from "@redotech/redo-concierge-settings-common/ai-tone-and-voice";
import * as z from "zod";
import {
  promptFixIssueSchema,
  promptFixSchema,
} from "../prompt-helper/prompt-fix";

/** The changes the fix card offers for one issue in the voice instructions; null when none could be written. */
export const draftShopperAgentToneAndVoiceFix = {
  name: "draftShopperAgentToneAndVoiceFix" as const,
  input: z.object({
    /** Untrimmed, since the issue's offsets index into this text. */
    voiceInstructions: z.string().max(VOICE_INSTRUCTIONS_MAX_LENGTH),
    issue: promptFixIssueSchema,
  }),
  output: z.object({ fix: promptFixSchema.nullable() }),
};
